(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function setMenuState(menu, isOpen) {
    const toggle = menu.querySelector('.footer-block__accordion-toggle');
    if (!toggle) return;

    menu.classList.toggle('is-open', isOpen);
    toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function initFooterAccordion(root) {
    const scope = root || document;
    const menus = Array.from(scope.querySelectorAll('.footer-block--menu'));

    menus.forEach((menu) => {
      const toggle = menu.querySelector('.footer-block__accordion-toggle');
      if (!toggle || toggle.dataset.nazvaFooterAccordionReady === 'true') return;

      toggle.dataset.nazvaFooterAccordionReady = 'true';
      toggle.addEventListener('click', () => {
        if (!mobileQuery.matches) return;

        const shouldOpen = !menu.classList.contains('is-open');
        menus.forEach((item) => setMenuState(item, item === menu ? shouldOpen : false));
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => initFooterAccordion(document));
  document.addEventListener('shopify:section:load', (event) => initFooterAccordion(event.target));
})();
